import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {addLives} from "../../../player/actions";
import {IApplicationState} from "../../../index";

export default function addLivesHandler({ payload, meta }: ActionType<typeof addLives>, { player }: IApplicationState): IAnalyticsAction | undefined {
    const action = payload > 0
        ? "get"
        : player.lives + payload > 0
            ? "spend"
            : "spend_all";

    return {
        category: "account",
        object: "life",
        name: action,
        addition: meta
    };
}